import React from 'react';

import styles from './PageHeader.module.css';

const PageHeader = props => {
  const {title, children} = props;

  return (
    <div className={styles.PageHeader}>
      <div className={styles.PageHeaderInner}>
        <h1 className={styles.Title}>{title}</h1>
        {children ? <div className={styles.Controls}>{children}</div> : null}
      </div>
    </div>
  );
};

export default PageHeader;
